import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=bc98acee&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc98acee')) {
      api.createRecord('bc98acee', component.options)
    } else {
      api.reload('bc98acee', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=bc98acee&", function () {
      api.rerender('bc98acee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8HOy3LHXORbfP/JS/offershelp.vue"
export default component.exports